import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

interface Props {
    files: File[];
}

export default function UserMediaPreviewItem({ files }: Props) {
    const { classes } = useStyles();

    const getFileExtension = (file: string) => {
        return file.substring(file.lastIndexOf('.'), file.length) || file;
    };
    return (
        <>
            <Typography variant="h6" mb={2}>
                Images Preview
            </Typography>

            <Grid
                item
                container
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                spacing={1}
                mb={2}
            >
                {files.map((file, index) => (
                    <Grid item key={index}>
                        {(file.type === 'image/jpeg' ||
                            file.type === 'image/webp' ||
                            file.type === 'image/png' ||
                            file.type === 'image/gif') && (
                            <img
                                src={URL.createObjectURL(file)}
                                alt="SMS"
                                className={classes.media}
                            />
                        )}
                        {file.type !== 'image/jpeg' &&
                            file.type !== 'image/webp' &&
                            file.type !== 'image/png' &&
                            file.type !== 'image/gif' && (
                                <Typography className={classes.txtExtension}>
                                    {getFileExtension(file.name)}
                                </Typography>
                            )}
                    </Grid>
                ))}
            </Grid>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    media: {
        maxWidth: '50px',
        maxHeight: '50px',
    },
    txtExtension: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(0.5),
        borderRadius: 4,
    },
}));
